import AutoTextarea from '../AutoTextarea'
import { emptySection } from '../../utils/descriptionSections'

/**
 * Authoring UI for progressive reveals.
 *
 * No title field and no reorder controls, both deliberate: a reveal is a
 * paragraph rather than a document section, and reordering is cut-and-paste
 * between boxes. Array order is authoring order and nothing here mutates it.
 */
export default function RevealsEditor({ sections, onChange }) {
  const list = Array.isArray(sections) ? sections : []

  const patch = (i, next) => onChange(list.map((s, idx) => (idx === i ? { ...s, ...next } : s)))
  const add = () => onChange([...list, emptySection()])
  const remove = (i) => onChange(list.filter((_, idx) => idx !== i))

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
      {list.map((section, i) => (
        <div
          key={i}
          style={{
            border: '1px solid var(--border-color)',
            borderLeft: `3px solid ${section.revealed ? '#2ecc71' : 'var(--text-muted)'}`,
            borderRadius: '8px',
            background: 'var(--bg-secondary)',
            padding: '0.45rem 0.7rem 0.6rem',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.55rem', marginBottom: '0.3rem' }}>
            <span style={{ color: 'var(--text-muted)', fontSize: '0.78rem', fontWeight: 700 }}>{i + 1}</span>
            <span style={{ flexGrow: 1 }} />
            <div style={{ display: 'flex', background: 'var(--bg-primary)', border: '1px solid var(--border-color)', borderRadius: '999px', padding: '2px', gap: '2px' }}>
              {[false, true].map((state) => (
                <button
                  key={String(state)}
                  type="button"
                  onClick={() => patch(i, { revealed: state })}
                  style={{
                    padding: '0.15rem 0.65rem',
                    borderRadius: '999px',
                    border: 'none',
                    cursor: 'pointer',
                    fontSize: '0.72rem',
                    fontWeight: 600,
                    fontFamily: 'inherit',
                    background: section.revealed === state ? (state ? '#27ae60' : 'var(--active-bg)') : 'transparent',
                    color: section.revealed === state ? '#ffffff' : 'var(--text-muted)',
                  }}
                >
                  {state ? 'Revealed' : 'Hidden'}
                </button>
              ))}
            </div>
            <button
              type="button"
              onClick={() => remove(i)}
              title="Remove this reveal"
              style={{
                background: 'transparent',
                border: 'none',
                color: 'var(--text-muted)',
                cursor: 'pointer',
                fontSize: '1rem',
                lineHeight: 1,
                padding: '0 0.15rem',
              }}
            >
              ×
            </button>
          </div>
          <AutoTextarea
            value={section.body}
            onChange={(e) => patch(i, { body: e.target.value })}
            placeholder="What the party learns later…"
          />
        </div>
      ))}

      <button
        type="button"
        onClick={add}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '0.5rem',
          padding: '0.55rem',
          border: '1px dashed var(--accent-teal)',
          borderRadius: '8px',
          background: 'transparent',
          color: 'var(--accent-cyan)',
          fontSize: '0.85rem',
          fontWeight: 600,
          fontFamily: 'inherit',
          cursor: 'pointer',
        }}
      >
        + Add reveal
      </button>
    </div>
  )
}
